import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FormGroup, OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import { customStyles, colourWayOptions, shortenString, shortenStringWithTooltip } from '../../../Components/helper';
import * as action from '../store/DevelopmentOrder.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';

const TEST_CODE_MAX_LENGTH = 200;
const TEST_CODE_DISPLAY_TRUNCATE = 30;
const TEST_PRICE_MAX_CHARS = 15;

function sanitizeTestPriceInput(raw) {
  if (raw == null || raw === '') {
    return '';
  }
  const sanitized = String(raw)
    .replace(/[^0-9.]/g, '')
    .replace(/(\..*)\./g, '$1');
  if (!/^\d*\.?\d{0,2}$/.test(sanitized)) {
    return null;
  }
  return sanitized.length > TEST_PRICE_MAX_CHARS ? sanitized.slice(0, TEST_PRICE_MAX_CHARS) : sanitized;
}

function HandleExpandedView({
  expandData,
  statusCalled,
  desc,
  code,
  addInfo,
  currentIndex,
  forEditId,
  supplierOptions,
  selectedSupplier,
  handleSelectSupplier,
  handleSelectBom,
  handleSelectType,
  type,
  handleChange,
  colourOptions,
  bomOptions,
  selectedColour,
  savedEdit,
  handleSelectColour,
  setRowEdit,
  hideBom,
  actionButtons,
  expandGrandTotalChild,
  selectedIdArray,
  onSelectCheckBox,
  selectedBom,
  parentIndexes,
  item,
  index,
  allData,
  setForEditId,
  fromBom,
  TestingDeleteAccess,
  testTypeMaster,
}) {
  const { t } = useTranslation('common');
  const Id = useParams();
  const devOrderID = Id.devOrderId;
  const dispatch = useDispatch();
  const ProductTestingData = useSelector((redState) => redState);
  const { UserDetails, BOMConfigDetails } = ProductTestingData;
  const { isSupplierLoggedIn } = UserDetails;
  const { isProductArchived } = BOMConfigDetails;
  const highlightedFieldLastFixColClass = 'highlighted-field first-fix-col';
  const lastFixColClass = 'first-fix-col';
  const highlightedFieldClass = 'highlighted-field';
  const [state, setState] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [addClassname, setAddClassname] = useState({
    classId: '',
    showRed: false,
  });

  const checkBox = (ele) => {
    return (
      !isSupplierLoggedIn &&
      !isProductArchived && (
        <td>
          <div className="common-checkbox no-label checkbox-center">
            <input
              onChange={(e) => onSelectCheckBox(e, ele._id)}
              name={`checks_${ele._id}`}
              id={`checks_${ele._id}`}
              type="checkbox"
              checked={selectedIdArray.filter((val) => val === ele._id).length > 0}
            />
            <label htmlFor={`checks_${ele._id}`} className="chklabel" />
          </div>
        </td>
      )
    );
  };

  const tableCode = (ele, eleIndex) => {
    return (
      <td
        className={ele?.highlightedKeys?.includes('code') ? highlightedFieldLastFixColClass : lastFixColClass}
        onClick={() => hideBom && setRowEdit(ele, eleIndex)}
      >
        <div>
          {currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === eleIndex && ele._id === forEditId ? (
            <FormGroup>
              <div>
                <input
                  name="code"
                  key={eleIndex}
                  disabled={savedEdit}
                  className="form-control custom-control-bordered"
                  value={ele.code}
                  type="text"
                  maxLength={TEST_CODE_MAX_LENGTH}
                  onChange={(e) => handleChange(e, ele, index + eleIndex, eleIndex)}
                />
              </div>
              <div className="character-counter ng-binding">
                {code != null ? String(code).length : String(ele?.code ?? '').length}/{TEST_CODE_MAX_LENGTH}
              </div>
            </FormGroup>
          ) : (
            <span>{shortenStringWithTooltip(ele?.code, TEST_CODE_DISPLAY_TRUNCATE)}</span>
          )}
        </div>
        {ele.isEmpty && (ele.code === null || ele.code === '') && (
          <label className="text-danger m-0 p-1">{t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.PLEASE_ENTER_TEST_CODE')}</label>
        )}
      </td>
    );
  };

  const tableDescription = (ele, eleIndex) => {
    return (
      <td className={ele?.highlightedKeys?.includes('description') && highlightedFieldClass} onClick={() => hideBom && setRowEdit(ele, eleIndex)}>
        <div>
          {currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === eleIndex && ele._id === forEditId ? (
            <FormGroup>
              <div>
                <input
                  name="description"
                  key={eleIndex}
                  className="form-control custom-control-bordered"
                  type="text"
                  maxLength="200"
                  value={ele.description}
                  onChange={(e) => handleChange(e, ele, index + eleIndex, eleIndex)}
                />
              </div>
              <div className="character-counter ng-binding">{desc?.length || 0}/200</div>
            </FormGroup>
          ) : (
            <span>{shortenString(ele?.description, 20)}</span>
          )}
        </div>
        {ele.isEmpty && (ele.description === null || ele.description === '') && (
          <label className="text-danger m-0 p-1">{t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.PLEASE_ENTER_TEST_DESCRIPTION')}</label>
        )}
      </td>
    );
  };

  const handleAdditionalInfo = (ele, eleIndex) => {
    return (
      <td className={ele?.highlightedKeys?.includes('additionalInformation') ? highlightedFieldClass : ''} onClick={() => hideBom && setRowEdit(ele, eleIndex)}>
        <div>
          {currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === eleIndex && ele._id === forEditId ? (
            <FormGroup>
              <div>
                <input
                  name="additionalInformation"
                  key={eleIndex}
                  className="form-control custom-control-bordered"
                  value={ele.additionalInformation}
                  onChange={(e) => handleChange(e, ele, index + eleIndex, eleIndex)}
                  type="text"
                  defaultValue={ele.additionalInformation}
                  maxLength="300"
                />
              </div>
              <div className="character-counter ng-binding">{addInfo?.length || 0}/300</div>
            </FormGroup>
          ) : (
            <span>{ele?.additionalInformation} </span>
          )}
        </div>
      </td>
    );
  };

  const handleTestPrice = (ele, eleIndex) => {
    return (
      <td className={ele?.highlightedKeys?.includes('testPrice') ? highlightedFieldClass : ''} onClick={() => hideBom && setRowEdit(ele, eleIndex)}>
        <div>
          {currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === eleIndex && ele._id === forEditId ? (
            <FormGroup>
              <div>
                <input
                  name="testPrice"
                  key={eleIndex}
                  className="form-control custom-control-bordered"
                  value={ele.testPrice ?? ''}
                  onChange={(e) => {
                    const next = sanitizeTestPriceInput(e.target.value);
                    if (next === null) {
                      return;
                    }
                    handleChange({ currentTarget: { name: 'testPrice', value: next } }, ele, index + eleIndex, eleIndex);
                  }}
                  type="text"
                  inputMode="decimal"
                  maxLength={TEST_PRICE_MAX_CHARS}
                />
              </div>
              <div className="character-counter ng-binding">
                {String(ele?.testPrice ?? '').length}/{TEST_PRICE_MAX_CHARS}
              </div>
            </FormGroup>
          ) : (
            <span>{ele?.testPrice} </span>
          )}
        </div>
      </td>
    );
  };

  const handleComments = (cmnt, cmntindex) => {
    return (
      <td className="increase-z-index last-fix-col" onClick={() => hideBom && setRowEdit(cmnt, cmntindex)}>
        <div className="position-static">
          {(currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === cmntindex) || !cmnt._id ? null : (
            <span>
              {statusCalled(cmnt)}

              <OverlayTrigger
                trigger="hover"
                rootClose
                overlay={
                  <Popover className="custom-popover modified-popover">
                    <Popover.Content>
                      <p className="mb-1">
                        <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.CREATED_BY')}: </span>
                        {cmnt?.approveRejectedBy && `${cmnt?.approveRejectedBy.firstName} ${cmnt?.approveRejectedBy?.lastName}`}
                      </p>
                      <p className="mb-1">
                        <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.DATE_TIME')}: </span>
                        {moment(cmnt?.selectedDate).format('DD-MMM-YYYY')}
                      </p>
                      {cmnt.result && (
                        <p className="mb-1">
                          <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.RESULT')}: </span>
                          {!isEmpty(cmnt?.result) ? cmnt?.result : '-'}
                        </p>
                      )}
                      {cmnt.comment && (
                        <p className="mb-1">
                          <span className="text-bold">{t('DEVLOPMENT_ORDER.TESTING.TABLE_ROW.COMMENT')}: </span>
                          {!isEmpty(cmnt?.comment) ? cmnt?.comment : '-'}
                        </p>
                      )}
                    </Popover.Content>
                  </Popover>
                }
              >
                <p className="text-truncate mt-1 d-block mb-0 line-h-normal">{cmnt.result ? cmnt.result : cmnt.comment}</p>
              </OverlayTrigger>
            </span>
          )}
        </div>
      </td>
    );
  };

  const hideExpandedData = (childItem, childIndex) => {
    return (
      <td>
        {!childItem.expandData && childIndex === 0 && (
          <button
            className="btn-up-down"
            type="button"
            onClick={() => {
              item.forEach((ele, is) => {
                if (ele?.expandData?.length > 1) {
                  parentIndexes.forEach((chEle, inds) => {
                    if (chEle === childItem._id) {
                      const r = item[is].expandData?.filter((element) => element._id === chEle);
                      if (!isEmpty(r)) {
                        expandGrandTotalChild(is, inds);
                      }
                    }
                  });
                }
              });
            }}
          >
            <span className="icon-new-down-arrow-icon icon-inverse" />
          </button>
        )}
      </td>
    );
  };

  const testTypeOptions = testTypeMaster?.filter((el) => el?.isActive === true);
  const tableType = (childItem, childIndex) => {
    const currentItems = allData.find((ele) => ele._id === childItem._id);
    return (
      <td className={currentItems?.highlightedKeys?.includes('type') && highlightedFieldClass} onClick={() => hideBom && setRowEdit(childItem, childIndex)}>
        <div>
          {currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === childIndex && childItem._id === forEditId ? (
            <div className="custom-react-select">
              <Select
                name="type"
                key={childIndex}
                maxMenuHeight={132}
                menuPosition="fixed"
                menuPlacement="top"
                options={testTypeOptions}
                getOptionLabel={(option) => `${option?.name}`}
                getOptionValue={(option) => `${option?._id}`}
                value={type}
                styles={customStyles}
                onChange={(e) => handleSelectType(e, childItem)}
                placeholder={t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.TESTING_CODE')}
              />
            </div>
          ) : (
            <span>{childItem?.type?.name}</span>
          )}
        </div>
        {childItem.isEmpty && (childItem.type === '' || childItem.type === null) && (
          <label className="text-danger m-0 p-1">{t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.TEST_TYPE_REQUIRED')}</label>
        )}
      </td>
    );
  };

  const tableMinPass = (childItem, childIndex) => {
    return (
      <td
        className={childItem?.highlightedKeys?.includes('minPassRate') ? highlightedFieldClass : ''}
        onClick={() => hideBom && setRowEdit(childItem, childIndex)}
      >
        <div>
          {currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === childIndex && childItem._id === forEditId ? (
            <FormGroup>
              <div>
                <input
                  name="minPassRate"
                  key={childIndex}
                  className="form-control custom-control-bordered"
                  value={childItem.minPassRate}
                  onChange={(e) => handleChange(e, childItem, index + childIndex, childIndex)}
                  type="text"
                  maxLength="300"
                />
              </div>
              <div className="character-counter ng-binding">
                {childItem?.minPassRate?.length}
                /300
              </div>
            </FormGroup>
          ) : (
            <span>{shortenStringWithTooltip(childItem?.minPassRate, 20)}</span>
          )}
        </div>
        {childItem.isEmpty && (childItem.minPassRate === null || childItem.minPassRate === '') && (
          <label className="text-danger m-0 p-1">{t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.PLEASE_ENTER_MIN_RATE')}</label>
        )}
      </td>
    );
  };

  const handleBom = (childItem, childIndex) => {
    const currentItems = allData.find((ele) => ele._id === childItem._id);
    return (
      !hideBom && (
        <td className={currentItems?.highlightedKeys?.includes('bomComponent') && highlightedFieldClass}>
          <div>
            {(currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === childIndex && childItem._id === forEditId) || !childItem._id ? (
              <div className="custom-react-select">
                <Select
                  name="selectedBom"
                  key={childIndex}
                  maxMenuHeight={132}
                  menuPosition="fixed"
                  menuPlacement="top"
                  options={bomOptions}
                  getOptionLabel={(option) => `${option.referenceCode}`}
                  getOptionValue={(option) => `${option._id}`}
                  value={selectedBom}
                  styles={customStyles}
                  onChange={(e) => handleSelectBom(e, childItem)}
                  placeholder={t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.BOM_COMPONENT')}
                />
              </div>
            ) : (
              <span>{childItem?.bomComponent?.referenceCode}</span>
            )}
          </div>
        </td>
      )
    );
  };

  useEffect(() => {
    expandData?.forEach((obj) => {
      if (obj?.testReport && obj?.testReport?.expiryDate) {
        const classColour = moment()?.isAfter(obj?.testReport?.expiryDate, 'seconds');
        setAddClassname({ classId: obj?._id, showRed: classColour });
      }
    });
  }, [expandData]);

  const toDate = (childItem) => {
    return childItem?.testReport?.expiryDate ? moment(childItem.testReport.expiryDate).format('DD-MMM-YYYY') : '--';
  };

  const forExpairyDateColour = (childItem) => {
    return addClassname.classId === childItem._id && addClassname.showRed ? 'text-danger' : 'text-success';
  };

  const handleDeleteTR = async (ele) => {
    setState(ele);
    setShowConfirmation(true);
  };

  const handleToggle = () => {
    setShowConfirmation(false);
    setState('');
  };

  const DeleteReport = async () => {
    const params = { id: devOrderID };
    const deleteParam = { libIds: state?.libId };
    const res = await dispatch(action.deleteTestingReport(deleteParam, devOrderID, state?.testReport?._id, t));
    if (res) {
      await dispatch(action.ProductTesting(params));
      await dispatch(action.fetchReportList({ id: devOrderID }));
      setShowConfirmation(false);
      setState('');
      if (fromBom) {
        setForEditId('');
        const getAttributes = {
          pageIndex: 1,
          pageSize: 20,
          devOrderId: devOrderID,
          bomComponent: state.bomComponent._id,
        };
        await dispatch(action.fetchProductBomTesting(getAttributes));
      }
    }
  };

  return (
    <>
      {expandData?.map((childItem, childIndex) => {
        const currentItems = allData.find((ele) => ele._id === childItem._id);
        return (
          <tr key={childItem?._id}>
            {checkBox(childItem)}
            {hideExpandedData(childItem, childIndex)}
            {tableCode(childItem, childIndex)}
            {tableDescription(childItem, childIndex)}
            {tableType(childItem, childIndex)}
            {tableMinPass(childItem, childIndex)}
            <td onClick={() => hideBom && setRowEdit(childItem, childIndex)}>
              {childItem?.testReport?.pdfTitle ? (
                <>
                  <span>{`${childItem?.testReport?.pdfTitle} | `}</span>
                  <span className={forExpairyDateColour(childItem)}>{toDate(childItem)}</span>
                  {(TestingDeleteAccess || fromBom) && (
                    <button type="button" onClick={() => handleDeleteTR(childItem)} className="btn" disabled={isProductArchived}>
                      <span className="icon-Delete-bold" />
                    </button>
                  )}
                </>
              ) : (
                ''
              )}
            </td>
            <td
              className={currentItems?.highlightedKeys?.includes('supplier') && highlightedFieldClass}
              onClick={() => hideBom && setRowEdit(childItem, childIndex)}
            >
              <div>
                {(currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === childIndex && childItem._id === forEditId) ||
                !childItem._id ? (
                  <div className="custom-react-select">
                    <Select
                      name="selectedSupplier"
                      key={childItem?._id}
                      maxMenuHeight={132}
                      menuPosition="fixed"
                      menuPlacement="top"
                      options={supplierOptions}
                      getOptionLabel={(option) => `${option?.name}`}
                      getOptionValue={(option) => `${option?._id}`}
                      value={selectedSupplier}
                      styles={customStyles}
                      onChange={(e) => handleSelectSupplier(e, childItem)}
                      placeholder={t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.SUPLIER')}
                    />
                  </div>
                ) : (
                  <span>{childItem?.supplier?.name}</span>
                )}
              </div>
            </td>
            {handleBom(childItem, childIndex)}
            <td
              className={currentItems?.highlightedKeys?.includes('colour') && highlightedFieldClass}
              onClick={() => hideBom && setRowEdit(childItem, childIndex)}
            >
              <div>
                {(currentIndex?.length === 2 && currentIndex?.[0] === index && currentIndex[1] === childIndex && childItem._id === forEditId) ||
                !childItem._id ? (
                  <div className="custom-react-select">
                    <Select
                      name="selectedColour"
                      key={childItem?._id}
                      maxMenuHeight={132}
                      menuPosition="fixed"
                      menuPlacement="top"
                      options={colourWayOptions(colourOptions)}
                      getOptionLabel={(option) => `${option.refName}`}
                      getOptionValue={(option) => `${option._id}`}
                      value={selectedColour}
                      styles={customStyles}
                      onChange={(e) => handleSelectColour(e, childItem)}
                      placeholder={t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.COLOR')}
                    />
                  </div>
                ) : (
                  <span>{childItem?.colour?.name} </span>
                )}
              </div>
            </td>
            {handleAdditionalInfo(childItem, childIndex)}
            {handleTestPrice(childItem, childIndex)}
            {handleComments(childItem, childIndex)}
            <td className="px-1 increase-z-index">
              <div className="table-action-container">{actionButtons(childItem, index, childIndex)}</div>
            </td>
          </tr>
        );
      })}
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={DeleteReport}
          loading={false}
          title={t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.REPORT_CONFIRMATION')}
          message={t('DEVLOPMENT_ORDER.TESTING.HANDLE_EXPANDED.DELETE_TEST_REPORT')}
          toggle={() => handleToggle()}
        />
      )}
    </>
  );
}

export default HandleExpandedView;
